module.exports = __webpack_public_path__ + "img/default-image.eab1c54f.jpg";